<template>
  <el-dialog title="Importar Planilha" center :close-on-click-modal="false" :visible.sync="dialog">
    <el-upload class="avatar-uploader" drag ref="upload" action="/api/audit/upload" :limit="1" :show-file-list="true"
      :auto-upload="false" :multiple="false" :on-change="changeFile">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        Arraste aqui ou <em>clique para upload</em>
      </div>
      <div class="el-upload__tip" slot="tip">csv/xls/xlsx files</div>
    </el-upload>
    <el-checkbox v-model="isEuEntregoFile" style="margin-top: 10px;">Planilha da Eu Entrego</el-checkbox>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialog = false">Cancelar</el-button>
      <el-button type="primary" @click="upload()">Importar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { AuditService } from "@/services/customers/audit.services";

export default {
  name: "AuditFileListImport",
  data() {
    return {
      dialog: false,
      isEuEntregoFile: false,
    };
  },
  methods: {
    open() {
      const vm = this;
      vm.dialog = true;
    },
    changeFile(file) {
      var vm = this;
      vm.file = file;
    },
    upload() {
      const vm = this;
      if (!vm.file) {
        return vm.$message({
          type: "error",
          message: 'Você deve selecionar um arquivo para realizar o upload',
        });
      }
      const loading = vm.$loading(vm.$options.loading);
      vm.state = 1;
      AuditService.upload(vm.file, vm.isEuEntregoFile)
        .then((response) => {
          vm.$emit("uploaded", response)
          vm.dialog = false;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
};
</script>
<style scoped>
.el-upload--text {
  width: 100%;
}

.el-upload--text {
  width: 100%;
}
</style>